// removed by extract-text-webpack-plugin
module.exports = {"Toolbar":"Toolbar__Toolbar__1bR3P","DesktopOnly":"Toolbar__DesktopOnly__AiQQX"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/Navigation/ToolBar/Toolbar.css
// module id = 99
// module chunks = 0